export default __webpack_public_path__ + "assets/audio/ssml/phoneme.136fadbd2d5b7516d4b4c15db16a3106.mp3";